import React, { useEffect } from "react";
import { useRouter } from "next/router";
// import EditIcon from "@public/images/edit_icon.svg";
import Image from "@components/imageContainer";
import { getWidgetSpecificIsVisible } from "@utils/index";
import { connect } from "react-redux";
import { resolvePath } from "@utils/resolvePath";
import { useOnload } from "@utils/useOnLoad";

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    is_visible: getWidgetSpecificIsVisible(
      state.configuration?.normalisedConfig,
      ownProps.id
    )
  };
};

const EditWidget = (props: any) => {
  const router = useRouter();
  const { proposal_ekey, current_node } = router.query;
  const { actions, label, is_visible } = props;

  const { on_click, on_load } = actions || {};

  useOnload({ on_load });

  const handleClick = () => {
    on_click?.forEach((action) => {
      if (action && typeof action.funCall === "function") {
        if (action?.funCall?.name === "fetchConfigAndRedirect") {
          action.args.shouldRedirect = true
        }
          action.funCall(action.args || {});
      }
    });
  };

  return is_visible ? (
    <div
      className="edit-icon-container"
      onClick={() => {
        handleClick();
      }}
    >
      <Image
        imgSrc={resolvePath("/images/edit_icon.svg")}
        alt="acko-logo"
        width={16}
        height={16}
      />
      {label}
      <style jsx>{`
        .edit-icon-container {
          display: inline-flex;
          cursor: pointer;
          align-items: center;
          color: #1b73e8;
          gap: 4px;
          text-align: right;
          font-size: 14px;
          font-weight: 500;
          line-height: 20px;
        }
      `}</style>
    </div>
  ) : (
    <></>
  );
};

export default connect(mapStateToProps)(EditWidget);
